import { DividerSchema } from '@/views/sports/components/Divider/styles/Divider.styles';

export const dividerStyles: DividerSchema = {
  boxWrapper: {
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    borderStyle: '1px solid',
    borderColor: '#0B3A5B',
  },
};
